import React from 'react';
import ReactDOM from 'react-dom';
import Livechat from './Components/Livechat';

const rootElement = document.getElementById('gr-livechat');
ReactDOM.render(<Livechat />, rootElement);
